import { Component } from '@angular/core';
import {
  AppContainerOptions,
  AppContainerService,
  UserMenuItemsEnum,
} from '@mydocma/app-container';
import { ConfigProvider } from '@mydocma/common';
import package_json from '../../../package.json';

@Component({
  selector: 'my-docma-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {
  public version: string = package_json.version as string;

  constructor(
    public options: AppContainerOptions,
    private appContainerService: AppContainerService,
  ) {
    const configProvider = ConfigProvider.instance;
    this.appContainerService.notifyChanges((appcontainer) => {
      appcontainer.appIcon.name = configProvider.getConfigData()?.appName;
      appcontainer.appIcon.color = configProvider.getConfigData()?.appIconColor;
      appcontainer.header.userMenuItems.version = this.version;
      appcontainer.header.userMenuItems.items.find(value => {
        if (value.id === UserMenuItemsEnum.userSettings) {
          value.hidden = true;
          return;
        }
      });
    });
  }
}
